const ErrorCode = {
  NETWORK_ERROR: 'ERR_NETWORK',
} as const;

export default ErrorCode;
